export { RatingStars, type IRatingStarsProps } from './rating-stars';
